import { BulkTicketPurchaseConfirmationProps } from "../../types";
import { PurchaseConfirmation } from "shared/components/purchaseOrder";
import { useParticipantDetails } from "apps/myExperience/context/participantDetails";
import { ConfirmationPageEntityType } from "shared/components/purchaseOrder/components/enum";

export default function BulkTicketPurchaseConfirmation(props: BulkTicketPurchaseConfirmationProps) {
  const { participantDetails } = useParticipantDetails();

  return (
    <PurchaseConfirmation
      entityQuantity={props.service.state.quantityPurchased}
      entityType={ConfirmationPageEntityType.BUY_BULK_TICKETS}
      isInvoicePaymentPending={props.service.isInvoicePaymentPending}
      approvalPending={props.service.state.purchaseOrder?.hasRequestedOfflinePayment}
      invoicePayerEmail={props.service.state.purchaseOrder?.invoicePaymentRequest?.invoicePayerEmail}
      closeHandler={() => {
        props.closeHandler();
      }}
      participantFullName={`${participantDetails?.firstName} ${participantDetails?.lastName}`}
      purchaseOrder={props.service.state.purchaseOrder}
    />
  );
}
